import React from 'react';
import '../Busy/styles/busy.css';

function Busy() {

    // <Google tag (gtag.js)
    // <script async src="https://www.googletagmanager.com/gtag/js?id=G-9NW7F30P0K"></script>
    // <script>
    //     window.dataLayer = window.dataLayer || [];
    //     function gtag(){dataLayer.push(arguments);}
    //     gtag('js', new Date());

    //     gtag('config', 'G-9NW7F30P0K');
    // </script>
    // Set the date we're counting down to
    var countDownDate = new Date("Dec 18, 2025 18:00").getTime();

    // Update the count down every 1 second
    var x = setInterval(function () {
        // Get todays date and time
        var now = new Date().getTime();

        // Find the distance between now an the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Display the result in an element with id="demo"
        document.getElementById("timer").innerHTML =
            days + "d " + hours + "h " + minutes + "m " + seconds + "s ";

        // If the count down is finished, write some text
        if (distance < 0) {
            clearInterval(x);
            document.getElementById("timer").innerHTML = ``;
        }
    }, 1000);

    return (
        <div class="row justify-content-center">
            <div class="col-md-10 main-title">
                <h1 className='title-busy'>COMING SOON</h1>
                {/* <p id="timer"></p> */}
                <h2 className='title-busy'>Website</h2>
                <h2 className='title-busy'>Under Construction</h2>
            </div>
        </div>
    );
};

export default Busy;